<mat-dialog-actions>
    <button mat-mini-fab color="warn" mat-dialog-close><mat-icon>close</mat-icon></button>
</mat-dialog-actions>
<mat-dialog-content class="mat-typography">
    <img [src]="data.UrlImagen" alt="Imagen Grande">
</mat-dialog-content>